import { createFileRoute } from '@tanstack/react-router';
import { RevenueDashboardPage } from '@/modules/revenue-dashboard/pages/RevenueDashboardPage';

export const Route = createFileRoute('/dashboard/revenue-dashboard/')({
  component: RevenueDashboardPage,
});
